import { useState } from "react";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { Field, inputCls } from "./Fields";
import { Textarea } from "../ui/textarea";

const BLANK = { name: "", email: "", mobile: "", subject: "", message: "" };

export default function EnquiryForm() {
  const [form, setForm] = useState(BLANK);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/enquiries", form);
      setDone(true);
      setForm(BLANK);
      toast.success("Message sent. We'll get back to you shortly.");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="enquiry-form" className="grid gap-5 sm:grid-cols-2">
      {done && <p data-testid="enquiry-success" className="rounded-xl bg-mint/10 p-4 text-sm text-mint-600 sm:col-span-2">Thank you! Your enquiry has been received.</p>}
      <Field label="Full Name" id="e-name"><input id="e-name" required minLength={2} className={inputCls} value={form.name} onChange={set("name")} data-testid="enquiry-name-input" /></Field>
      <Field label="Email" id="e-email"><input id="e-email" required type="email" className={inputCls} value={form.email} onChange={set("email")} data-testid="enquiry-email-input" /></Field>
      <Field label="Mobile (optional)" id="e-mobile"><input id="e-mobile" type="tel" className={inputCls} value={form.mobile} onChange={set("mobile")} data-testid="enquiry-mobile-input" /></Field>
      <Field label="Subject" id="e-subject"><input id="e-subject" required minLength={2} className={inputCls} value={form.subject} onChange={set("subject")} data-testid="enquiry-subject-input" /></Field>
      <div className="sm:col-span-2">
        <Field label="Message" id="e-msg"><Textarea id="e-msg" required minLength={5} rows={5} className="rounded-xl border-slate-200 bg-white" value={form.message} onChange={set("message")} data-testid="enquiry-message-input" /></Field>
      </div>
      <button type="submit" disabled={loading} data-testid="enquiry-submit-btn"
        className="inline-flex w-fit items-center gap-2 rounded-full bg-navy px-7 py-3.5 text-sm font-semibold text-white transition-[transform,background-color] hover:-translate-y-0.5 hover:bg-navy-700 disabled:opacity-60">
        {loading ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} />} Send Message
      </button>
    </form>
  );
}
